<template>
    <div class="product-list favorites page-wrapper">

        <div class="product-list-loader center" v-loading="loading"  :class="{'hide': !loading}"></div>

        <p class="product-list-title">
            {{this.total}} items <br/>
        </p>

        <div class="product-list-inner" :class="{'medium': settings.productSize == 'medium'}">

            <div class="product-list-item"
                 :class="{'selected': item.selected}"
                 v-for="(item, index) in products"
                 :key="item.id">
                <div class="product-list-item-inner">

                    <label v-if="selectMode" class="select" :class="{'active': item.selected }">
                        <el-checkbox @change="massItemSelected($event, item)" :checked="item.selected"></el-checkbox>
                    </label>

                    <a @click.prevent="productClickAction($event, item)" class="product-list-item-link" :style="'background-image: url(' + getbase64EncodedImage(item.attributes) + ')'">
                    </a>

                    <div class="product-action" v-if="!selectMode">
                        <p @click="download(item)" class="product-action-item">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="11.529" height="14" viewBox="0 0 11.529 14"><defs><clipPath id="clip-path"><rect width="11.529" height="14" fill="none"/></clipPath></defs><g id="Icon_-_download" data-name="Icon - download" clip-path="url(#clip-path)"><path id="ic_get_app_24px" d="M16.529,7.941H13.235V3H8.294V7.941H5l5.765,5.765ZM5,15.353V17H16.529V15.353Z" transform="translate(-5 -3)" fill="#666"/></g></svg>
                            download
                        </p>
                        <p class="product-action-item" v-if="$store.state.favorites.includes(parseInt(item.id))" @click="removeFromFavorites(item,index)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="13.999" height="13.3" viewBox="0 0 13.999 13.3"><path id="Union_1" data-name="Union 1" d="M-2291-4477.311l-4.326,2.611,1.148-4.921-3.822-3.31,5.032-.427L-2291-4488l1.967,4.633,5.032.435-3.815,3.31,1.141,4.921Zm-4.256-4.732.1.085-.076-.087Z" transform="translate(2298 4488)" fill="#666"/></svg>
                            remove from favorites
                        </p>
                        <p v-else class="product-action-item" @click="addToFavorites(item)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13.3" viewBox="0 0 14 13.3"><path id="ic_star_border_24px" d="M16,7.068l-5.033-.434L9,2,7.033,6.641,2,7.068l3.822,3.311L4.674,15.3,9,12.689,13.326,15.3l-1.141-4.921ZM9,11.38,6.368,12.969l.7-3L4.744,7.957,7.81,7.691,9,4.87,10.2,7.7l3.066.266L10.939,9.98l.7,3Z" transform="translate(-2 -2)" fill="#666"/></svg>
                            add to favorites
                        </p>
                        <p v-if="$store.state.request.findIndex(function (req) {
                          return parseInt(req.id) === parseInt(item.id)
                        }) === -1" class="product-action-item" @click="addToCart(item)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#666" fill-rule="evenodd" clip-rule="evenodd" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 386 386"><defs/><defs/><path d="M13 0h66c6 0 12 4 13 10l13 74h268c9 0 15 8 12 16l-41 135c-2 5-7 9-12 9H135l6 32h184c16 0 16 25 0 25H130c-6 0-11-4-12-10L69 25H13C-4 25-4 0 13 0zm97 109l20 110 192-1 34-109H110zM166 315c19 0 35 16 35 36 0 19-16 35-35 35-20 0-36-16-36-35 0-20 16-36 36-36zm0 26c-6 0-11 4-11 10 0 5 5 10 11 10 5 0 10-5 10-10 0-6-5-10-10-10zM290 315c19 0 35 16 35 36 0 19-16 35-35 35-20 0-36-16-36-35 0-20 16-36 36-36zm0 26c-6 0-11 4-11 10 0 5 5 10 11 10 5 0 10-5 10-10 0-6-5-10-10-10z" class="fil0"/></svg>
                            add to cart
                        </p>
                        <p v-else class="product-action-item" @click="removeFromCart(item)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill-rule="evenodd" clip-rule="evenodd" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 386 379"><defs/><defs/><path fill-rule="nonzero" d="M13 0h66c6 0 12 4 13 10l13 74h268c9 0 15 8 12 16l-41 135c-2 5-7 9-12 9H135l6 32h184c16 0 16 25 0 25H130c-6 0-11-4-12-10L69 25H13C-4 25-4 0 13 0z"/><path d="M164 318c17 0 31 14 31 30 0 17-14 31-31 31-16 0-30-14-30-31 0-16 14-30 30-30zM287 318c17 0 30 14 30 30 0 17-13 31-30 31s-30-14-30-31c0-16 13-30 30-30z" class="fil1"/></svg>
                            remove from cart
                        </p>
                        <p class="product-action-item" @click="share(item)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12.651" height="14" viewBox="0 0 12.651 14"><path id="ic_share_24px" d="M13.542,11.9a2.047,2.047,0,0,0-1.378.541L7.154,9.52a2.3,2.3,0,0,0,.063-.492,2.3,2.3,0,0,0-.063-.492l4.955-2.889a2.1,2.1,0,1,0-.675-1.539A2.3,2.3,0,0,0,11.5,4.6L6.542,7.489a2.108,2.108,0,1,0,0,3.078l5,2.924a1.983,1.983,0,0,0-.056.457A2.052,2.052,0,1,0,13.542,11.9Z" transform="translate(-3 -2)" fill="#666"/></svg>
                            share
                        </p>
                    </div>
                </div>

                <div class="product-list-item-details" :class="{'active': settings.productDetails === 'show'}">
                    <p v-if="typeof item.attributes.Filename !== 'undefined'" class="product-list-item-details-meta">{{ item.attributes.Filename[0] }}</p>
                    <p v-if="typeof item.attributes['Directory Path'] !== 'undefined'" class="product-list-item-details-meta special">{{ item.attributes['Directory Path'][0] | formatFolderName }}</p>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { HTTP } from '@/services/api'
import { EventBus } from '@/services/eventbus'

export default {
  name: 'Share',
  metaInfo () {
    return {
      title: 'Share'
    }
  },
  data () {
    return {
      productSelect: {
        clickCount: 0,
        clickTimer: null,
        clickDelay: 300
      },
      loading: false,
      settings: {
        productSize: 'small',
        productDetails: 'hide'
      },
      products: [],
      selected: [],
      total: 0,
      windowWidth: 0,
      selectMode: false
    }
  },
  watch: {
    selected: function (val) {
      EventBus.$emit('selected-products', val)
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  mounted () {
    this.settings.productSize = window.localStorage.getItem('productSize') ? window.localStorage.getItem('productSize') : 'small'
    this.settings.productDetails = window.localStorage.getItem('productDetails') ? window.localStorage.getItem('productDetails') : 'hide'
    EventBus.$on('set-product-details', (payload) => (this.settings.productDetails = payload))
    EventBus.$on('select-mode', (payload) => (this.toggleSelectMode(payload)))
    EventBus.$on('bulk-add-to-cart', this.bulkAddToCart)
    this.loadData()
  },
  destroyed () {
    EventBus.$off('set-product-details')
    EventBus.$off('select-mode')
    EventBus.$off('bulk-add-to-cart')
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    getbase64EncodedImage (item) {
      if (typeof item['com.extensis.portfolio.Preview'] !== 'undefined') {
        return 'data:image/jpeg;base64,' + item['com.extensis.portfolio.Preview'][0].replace(/(\r\n|\n|\r)/gm, '')
      } else if (typeof item['Thumbnail'] !== 'undefined') {
        return 'data:image/jpeg;base64,' + item['Thumbnail'][0].replace(/(\r\n|\n|\r)/gm, '')
      }
    },
    loadData () {
      if (!this.loading) {
        this.loading = true
        HTTP({
          method: 'GET',
          url: '/api/v1/linkshare/shared/' + this.$route.params.hash,
          crossdomain: true
        }).then(response => {
          this.products = []
          this.products = response.data.data.assets
          this.total = response.data.data.totalNumberOfAssets
          this.loading = false
        }).catch(() => {
          this.loading = false
          this.products = []
          this.total = 0
        })
      }
    },
    toggleSelectMode (payload) {
      if (!payload) {
        this.selectMode = false
        this.selected = []
        this.products.forEach(function (item) {
          item.selected = false
        })
      } else {
        this.selectMode = true
      }
    },
    productClickAction (event, item) {
      if (this.selectMode) {
        this.$set(item, 'selected', !item.selected)
        this.setSelectedArray(item.id, !item.selected)
      } else {
        this.$router.push('/products/' + item.id)
      }
    },
    setSelectedArray (itemId, remove) {
      if (remove) {
        this.selected.splice(this.selected.indexOf(parseInt(itemId)), 1)
        this.$forceUpdate()
        return
      }
      this.selected.push(parseInt(itemId))
      this.$forceUpdate()
    },
    massItemSelected (event, item) {
      this.$set(item, 'selected', !item.selected)
      this.setSelectedArray(item.id, !item.selected)
    },
    addToFavorites (product) {
      HTTP({
        method: 'POST',
        url: '/api/v1/favorites',
        crossdomain: true,
        data: {
          ids: [product.id]
        }
      })
        .then(response => {
          if (response.data.data) {
            this.$store.dispatch('setFavorites', response.data.data)
            this.$notify({
              // title: 'Success',
              message: 'Added to saved items',
              type: 'success',
              position: 'bottom-right',
              duration: 1750
            })
          }
        })
        .catch((error) => {
          this.$notify({
            // title: 'Error',
            dangerouslyUseHTMLString: true,
            message: error.response.data ? this.parseErrorMessage(error.response.data.error) : 'Error occured. Please try later',
            type: 'error',
            position: 'bottom-right',
            duration: 1750
          })
        })
    },
    removeFromFavorites (product) {
      HTTP({
        method: 'DELETE',
        url: '/api/v1/favorites',
        crossdomain: true,
        data: {
          ids: [product.id]
        }
      })
        .then(response => {
          if (response.data.data) {
            this.$store.dispatch('setFavorites', response.data.data)
            this.$notify({
              // title: 'Success',
              message: 'Removed from saved items',
              type: 'success',
              position: 'bottom-right',
              duration: 1750
            })
          }
        })
        .catch((error) => {
          this.$notify({
            // title: 'Error',
            dangerouslyUseHTMLString: true,
            message: error.response.data ? this.parseErrorMessage(error.response.data.error) : 'Error occured. Please try later',
            type: 'error',
            position: 'bottom-right',
            duration: 1750
          })
        })
    },
    addToCart (product) {
      this.$store.dispatch('addRequestItem', product)
      this.$notify({
        message: 'Added to selects',
        type: 'success',
        position: 'bottom-right',
        duration: 1750
      })
    },
    removeFromCart (item) {
      this.$store.dispatch('removeRequestItem', {
        item: item,
        all: false
      })
      this.$notify({
        message: 'Removed from selects',
        type: 'success',
        position: 'bottom-right',
        duration: 1750
      })
    },
    bulkAddToCart () {
      if (this.selected.length) {
        let scope = this
        let products = this.products.filter(function (item) {
          return scope.selected.indexOf(parseInt(item.id)) > -1
        })
        if (products.length) {
          products.forEach(function (item) {
            scope.$store.dispatch('addRequestItem', item)
          })
          this.$notify({
            message: 'Added to selects',
            type: 'success',
            position: 'bottom-right',
            duration: 1750
          })
        }
      } else {
        this.$notify({
          message: 'Please select product/s',
          type: 'error',
          position: 'bottom-right',
          duration: 1750
        })
      }
    },
    handleResize () {
      this.windowWidth = window.innerWidth
    }
  }
}
</script>
